import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {SellableReportSelectionData} from "../../../catalogue/sellable/controls/sellable-report-selection-control.component";
import {EmployeeReportSelectionData} from "../../../employee/employee/controls/employee-report-selection-control.component";


export class VoidAuditReportData extends ReportData<VoidAuditReportData> {
    @collection() groupBy: string[] = ["none"];
    @field reportType: string = "SIMPLE";
    @collection(SellableReportSelectionData) sellables: SellableReportSelectionData[];
    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];

}
